import React from 'react';
import "./index.css"
import BsyDialog from "../../../../components/BsyDialog";
import AlertListSelectAppPopupPane from "../../../../components/BsyAlertListDetail/selectAppPopupPane";
import axios from 'axios';
import tipAlert from "../../../../Login/BsyAlertTip/Staticize";
import _ from 'lodash';
import BsyComboBox from "../../../../components/BsyComboBox";
import BsyFilterPane from '../../../../components/BsyFilterPane';
import BsyMsgBubble from '../../../../components/BsyMsgBubble';
import { BsyUtils } from '../../../../utils/Utils';
import classNames from 'classnames';

class BsyConfigurationBulletinConfig extends React.Component {
    constructor(props) {
        super(props);
        console.log(props.dynamicDialogObj.upLouadListTitleAndLink)
        this.state = {
            numberValue: props.dynamicDialogObj.numberValue || 6,
            modelFromData: props.dynamicDialogObj.modelFromData || {},
            titleValue: props.dynamicDialogObj.titleValue || '',
            dateValue: props.dynamicDialogObj.dateValue || '',
            linkValue: props.dynamicDialogObj.linkValue || '',
            upLouadListTitleAndLink: props.dynamicDialogObj.upLouadListTitleAndLink || [],
            upLouaListDate: props.dynamicDialogObj.upLouaListDate || [],
            allUpDataList: props.dynamicDialogObj.allUpDataList || [],
            reloadComboBox: true,
        };
        this.filterPaneContext = ''
        this.numberValue = 6
        this.modelFromData = props.dynamicDialogObj.modelFromData || {}
        this.rel = props.dynamicDialogObj.rel || "and"
        this.filter = props.dynamicDialogObj.filter || []
    }
    editNumber = (event) => {
        let value = event.target.value;
        if (event.target.value > 6) {
            value = 6;
        }
        this.setState({
            numberValue: parseInt(parseFloat(value)),
        });
    }
    addNumberValueFn = () => {
        let numberValue = this.state.numberValue
        if (numberValue >= 6) {
            numberValue = 6
        } else {
            numberValue += 1
        }
        this.setState({
            numberValue: numberValue,
        });
    }
    reductionNumberValueFn = () => {
        let numberValue = this.state.numberValue
        if (numberValue <= 1) {
            numberValue = 1
        } else {
            numberValue -= 1
        }
        this.setState({
            numberValue: numberValue,
        });
    }
    getPopupValue = (ref) => {
        if(!_.isEmpty(ref.appinfo)){
            this.modelFromData = ref
        }
    };
    blurChange = (event) => {
        let value = event.target.value;
        if (value <= 0 || value === '') {
            value = 1;
        }
        this.setState({
            numberValue: parseInt(parseFloat(value)),
        });
    }
    deleteModelFromDataFn = (event) => {
        event.stopPropagation()
        this.modelFromData = {}
        this.setState({
            modelFromData: {},
            titleValue: '',
            dateValue: '',
            linkValue: '',
        });
    }
    chooselinkType = () => {
        BsyDialog({
            title: React.language("form.select"),
            height: 540,
            width: 720,
            okText: React.language("ok"),
            cancelText: React.language("cancel"),
            onContentCreate: () => {
                return (
                    <AlertListSelectAppPopupPane
                        // showTypeList={['dash']}
                        noHome={true}
                        appid={this.state.modelFromData.appid}
                        formid={this.state.modelFromData.formid}
                        getValue={this.getPopupValue}
                    />
                );
            },
            onOk: () => {
                if (this.state.modelFromData.formid === this.modelFromData.formid) { return } //前后选择一样的不继续执行
                this.setState({
                    modelFromData: this.modelFromData,
                    reloadComboBox: false
                })
                if (!_.isEmpty(this.modelFromData)) {
                    console.log('发送', this.modelFromData)
                    React.axios("/dashboard/app/" + this.modelFromData.appid + "/entry/" + this.modelFromData.formid, { appId: this.modelFromData.appid, entryId: this.modelFromData.formid })
                        .then((res) => {
                            let list = res.data.entry.content.items
                            var newArr = list.map(item => ({
                                text: item.label,
                                type: item.widget.type,
                                value: item.widget.widgetName,
                                name: item.widget.widgetName,
                                id: this.modelFromData.formid,
                                appId: res.data.entry.appId,
                                items: item.widget.type === "subform" ? item.widget.items : []
                            }))
                            const authGroupId = res.data.authGroups.find((item) => ![0,-1].includes(item.groupId)  )?.groupId

                            this.setState({
                                reloadComboBox: true,
                                titleValue: '',
                                dateValue: '',
                                linkValue: '',
                                authGroupId:authGroupId,
                                upLouadListTitleAndLink: newArr.filter((item) => {
                                    return item.type === "text" || item.type === "textarea" || item.type === "radiogroup" || item.type === "combo" || item.type === "sn"
                                }),
                                upLouaListDate: newArr.filter((item) => {
                                    return item.type === "datetime"
                                }),
                                allUpDataList: newArr

                            })
                        })
                        .catch((err) => {
                            tipAlert({
                                type: "warning",
                                msg: err,
                            });
                        })
                        .finally(() => { });
                }
            }
        });
    }
    setEmitData = () => {
        let dynamicDialogObj = {
            modelFromData: this.state.modelFromData,
            titleValue: this.state.titleValue,
            dateValue: this.state.dateValue,
            linkValue: this.state.linkValue,
            numberValue: this.state.numberValue,
            upLouadListTitleAndLink: this.state.upLouadListTitleAndLink,
            upLouaListDate: this.state.upLouaListDate,
            allUpDataList: this.state.allUpDataList,
            filter: this.filter || [],
            rel: this.rel || "and"
        }
        return dynamicDialogObj
    }
    deleteComplete = () => {
        this.props.emitDynamicComplete(null, null, 'close', this.setEmitData())
    }
    emitDynamicComplete = () => {
        let Obj = {
            modelFromData: this.state.modelFromData,
            titleValue: this.state.titleValue,
            dateValue: this.state.dateValue,
            linkValue: this.state.linkValue,
            numberValue: this.state.numberValue,
            filter: {
                cond: this.filter || [],
                rel: this.rel || "and"
            }

        }
        React.axios("/data/notice_data_list", Obj)
            .then((res) => {
                this.props.emitDynamicComplete(res.data.data, Obj, 'complate', this.setEmitData())
            })
            .catch((err) => {
                tipAlert({
                    type: "warning",
                    msg: err,
                });
            })
            .finally(() => { });

    }
    setFilterCache = (val) => {
        BsyUtils.Store.set(this.getFilterCacheKey(), val)
    }
    getFilterConfig = () => {
        console.log()
        let entryList = {
            [this.state.modelFromData.formid]: {
                id: this.state.modelFromData.formid,
                name: this.state.modelFromData.name,
                fields: this.state.allUpDataList
            }
        }
        return {
            baseCls: "bsy-filter-pane t-guration-dialog",
            hasSticky: false,
            hasHeader: false,
            hasPin: true,
            hasRelation: 1,
            authGroupId: this.state.authGroupId,
            rel: this.rel || "and",
            entryList: entryList,
            filterSticky: false,
            filterTopSticky: false,
            cond: this.filter || [],
            onFilterClose: () => {
                window.$('.bsy-msg-bubble').remove()
            },
            onFilterSticky: () => {
                console.log(22)
            },
            onFilterTopSticky: () => {
                console.log(55)
            },
            onSetFieldFilter: (val) => {
                console.log(33)

                // this.rel = val.rel;
                // this.filter = [...val.cond];
            },
            onFilter: (val, clearFilter) => {
                console.log(44, clearFilter)
                this.rel = val.rel;
                if (clearFilter) {
                    this.filter = [];
                } else {
                    this.filter = [...val.cond];
                    window.$('.bsy-msg-bubble').remove()
                }


            },
        }
    }
    onGetFilterPaneContext = (context) => {
        this.filterPaneContext = context
    }
    hoverEnterPanel = (event) => {
        BsyMsgBubble({
            anchor: event.currentTarget,
            dockPosition: "center",
            text4Ok: null,
            width: 280,
            text4Cancel: null,
            edge: 50,
            // hAdjust: add(item.text) / 3,
            contentHTML: () => {
                return (<div className='t-notice-tip-quiker'>配置样式一和样式三最多展示6条，样式二最多展示3条，其他更多数据展示在【查看更多】页面</div>)
            },
        });
    }
    hoverLeavePanel = () => {
        window.$('.bsy-msg-bubble').remove()
    }
    render() {
        console.log(this.state.titleValue)
        console.log(this.state.upLouadListTitleAndLink)
        return <div className='configuration-bulletin-page'>
            <div className='page-title'>{React.language("dashboard.dynamic.data.source")}</div>
            <div className='ok-btn' onClick={() => {
                this.emitDynamicComplete()
            }}>{React.language("done")}</div>
            <div className='close-btn' onClick={() => {
                this.deleteComplete()
            }}>{React.language("editer_close")}</div>
            <div>
                <div className='title'>{React.language("workbench.noticeBoard.add.outlin")}</div>
                <div className={classNames(_.isEmpty(this.state.modelFromData) ? "choose-type has-up" : "choose-type has-close")} onClick={() => {
                    this.chooselinkType()
                }}>
                    {
                        _.isEmpty(this.state.modelFromData) && <span>{React.language("select.form")}</span>
                    }
                    {
                        !_.isEmpty(this.state.modelFromData) && <div className="has-icon">
                          <span className={"parent-icon color-cover-" + this.state.modelFromData.appinfo.style.color} >
                                  <span className={"imgbg-bby-app imgbg-bby-app-" + (this.state.modelFromData.appinfo.style.icon)}></span>
                                </span>
                            <span>{this.state.modelFromData.appinfo.appname}</span>
                            <span className="line">—</span>
                            <span>{this.state.modelFromData.name}</span>
                        </div>
                    }
                    <i className="icon-down1"></i>
                    <i className="icon-dingding-guide-close close" onClick={this.deleteModelFromDataFn}></i>
                </div>
            </div>
            <div className='box'>
                <div className='title'>{React.language("label")}</div>
                <div className='title-combox'>
                    {
                        this.state.reloadComboBox && <BsyComboBox ref={this.comboBoxRef}
                            height={34}
                            baseCls="BsySelect title-combox"
                            // textField="text"
                            // valueField="name"
                            items={
                                this.state.upLouadListTitleAndLink
                            }
                            allowBlank={!1}
                            width='268'
                            value={this.state.titleValue}
                            onStopEdit={(t, sec, context) => {
                                console.log(t)
                                this.setState({
                                    titleValue: t
                                })
                            }}
                        />
                    }
                </div>
            </div>
            <div className='box'>
                <div className='title'>{React.language("date")}</div>
                <div className='title-combox'>
                    {
                        this.state.reloadComboBox && <BsyComboBox ref={this.comboBoxRef}
                            height={34}
                            baseCls="BsySelect title-combox"
                            // textField="text"
                            // valueField="name"
                            items={
                                this.state.upLouaListDate
                            }
                            allowBlank={!1}
                            width='auto'
                            value={this.state.dateValue}
                            onStopEdit={(t, sec, context) => {
                                this.setState({
                                    dateValue: t
                                })
                            }}
                        />
                    }
                </div>
            </div>
            <div className='box'>
                <div className='title'>{React.language("richtext.link")}</div>
                <div className='title-combox'>
                    {
                        this.state.reloadComboBox &&
                        <BsyComboBox ref={this.comboBoxRef}
                            height={34}
                            baseCls="BsySelect"
                            // textField="text"
                            // valueField="name"
                            items={
                                this.state.upLouadListTitleAndLink
                            }
                            allowBlank={!1}
                            width='auto'
                            value={this.state.linkValue}
                            onStopEdit={(t, sec, context) => {
                                this.setState({
                                    linkValue: t
                                })
                            }}
                        />
                    }
                </div>
            </div>
            <div className='box'>
                <div className='title'>{React.language("filter.condition")}</div>
                <div className={classNames(_.isEmpty(this.state.modelFromData) ? "choose-select no-event" : "choose-select")} onClick={(e) => {
                    let config = this.getFilterConfig()
                    BsyMsgBubble({
                        // anchor: e.currentTarget,
                        customCls: 't-filter-bubble',
                        onGetContext: this.onGetFilterPaneContext,
                        contentHTML: (ref) => {
                            return <BsyFilterPane
                                {...config}
                            ></BsyFilterPane>
                        },
                        text4Cancel: null,
                        text4Ok: null,
                        // theme: this.props.theme,
                        minWidth: "auto",
                        width: 350,
                        contentPadding: 0,
                        edge: 200,
                        hAdjust: 72,
                        dockPosition: "right",
                        onClose: function () {
                            return !1

                        }
                    })
                }}>
                    <span>{React.language("set.filter.criteria")}</span>
                </div>
            </div>
            <div className='box'>
                <div className='title'><span>{React.language("workbench.noticeBoard.add.number")}</span><i className='icon-bsy-help'
                    onMouseEnter={(event) => {
                        this.hoverEnterPanel(event)
                    }} onMouseLeave={(event) => {
                        this.hoverLeavePanel(event)
                    }}></i></div>
                <div className='number-d'>
                    <input type="number" className="t-input" placeholder="请输入链接" onBlur={this.blurChange} value={this.state.numberValue}
                        onInput={(event) => {
                            this.editNumber(event);
                        }}
                    ></input>
                    <div className='num-change'>
                        <i className='icon-up' onClick={this.addNumberValueFn}></i>
                        <i className='icon-down' onClick={this.reductionNumberValueFn}></i>
                    </div>
                </div>
            </div>
        </div>;
    }
}


export default BsyConfigurationBulletinConfig;